import { AuditLog } from 'api/Clients/Types/AuditLog'
import { SymbolDto } from 'api/MetaTrader/SymbolDto'
import { UpdateSwapServerValues } from 'routes/Brokerage/Platforms/TransactionNegativeEquity/BrokeragePlatformSwapsPage'

import { SessionPreviewDto } from '../../api/MetaTrader/SessionDto'
import { ApiClient } from './ApiClient'

export enum PlatformType {
  metatrader4 = 'metatrader4',
  metatrader5 = 'metatrader5',
}

export const isMT4PlatformType = (platformType: string): boolean => {
  return platformType === PlatformType.metatrader4
}

export const isMT5PlatformType = (platformType: string): boolean => {
  return platformType === PlatformType.metatrader5
}

export class MetaTraderApiClient {
  constructor(private apiClient: ApiClient) {}

  getSymbols: (platform: PlatformType, serverId: string) => Promise<SymbolDto[]> = (
    platform,
    serverId
  ) => {
    return this.apiClient.get(`${platform}/configurations/symbols/${serverId}`)
  }
  getPlatformSwaps: (
    platform: PlatformType,
    serverId: string,
    symbolId: string
  ) => Promise<AuditLog[]> = (platform, serverId, symbolId) => {
    return this.apiClient.get(
      `${platform}/configurations/symbols/${serverId}/swaps/${symbolId}/events`
    )
  }
  updatePlatformSwaps: (platform: PlatformType, data: UpdateSwapServerValues) => Promise<void> = (
    platform,
    data
  ) => {
    return this.apiClient.put(`${platform}/configurations/symbols/swaps`, data)
  }
  uploadSessionsPreview: (
    platform: PlatformType,
    formData: FormData
  ) => Promise<SessionPreviewDto[]> = (platform, formData) => {
    return this.apiClient.upload(
      'POST',
      `${platform}/configurations/sessions/upload/preview`,
      formData
    )
  }
  uploadSessionsFile: (platform: PlatformType, formData: FormData) => Promise<void> = (
    platform,
    formData
  ) => {
    return this.apiClient.upload('POST', `${platform}/configurations/sessions/csv`, formData)
  }
}
